import { Component } from '@angular/core';

@Component({
  selector: 'imm-client-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss']
})
export class TermsOfServiceComponent {

}
